import { Component, OnInit } from '@angular/core';
import { ApisService } from '@core/services/apis.service';

@Component({
  selector: 'app-monetization-requests',
  templateUrl: './monetization-requests.component.html',
  styleUrls: ['./monetization-requests.component.scss'],
})
export class MonetizationRequestsComponent implements OnInit {
  loading = false;
  status: 'pending' | 'approved' | 'rejected' | 'disabled' | 'all' = 'all';

  items: any[] = [];
  selected: any = null;

  adminNote = '';
  saving = false;

  constructor(private apis: ApisService) {}

  formatDate(value: any): string {
    if (!value) return '';

    // Handle ISO string or "YYYY-MM-DD HH:mm:ss"
    let d: Date | null = null;
    try {
      if (typeof value === 'string') {
        const v = value.trim();
        // Normalize common MySQL format
        if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(v)) {
          d = new Date(v.replace(' ', 'T'));
        } else {
          d = new Date(v);
        }
      } else {
        d = new Date(value);
      }
    } catch (e) {
      d = null;
    }

    if (!d || isNaN(d.getTime())) return String(value);

    try {
      // Use Cairo time by default
      const datePart = new Intl.DateTimeFormat('ar-EG', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        timeZone: 'Africa/Cairo',
      }).format(d);

      const timePart = new Intl.DateTimeFormat('ar-EG', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
        timeZone: 'Africa/Cairo',
      }).format(d);

      // Ex: 19/03/2026 - 05:53 م
      return `${datePart} - ${timePart}`;
    } catch (e) {
      return d.toLocaleString();
    }
  }

  ngOnInit(): void {
    this.load();
  }

  setStatus(s: 'pending' | 'approved' | 'rejected' | 'disabled' | 'all'): void {
    if (this.status === s) return;
    this.status = s;
    this.load();
  }

  disable(): void {
    if (!this.selected?.id) return;

    const reason = (this.adminNote || '').trim();
    if (!reason) return;

    this.saving = true;
    this.apis.disableDashboardMonetizationRequest(this.selected.id, { admin_note: reason }).subscribe({
      next: () => {
        this.saving = false;
        this.load();
      },
      error: () => {
        this.saving = false;
      },
    });
  }

  enable(): void {
    if (!this.selected?.id) return;

    this.saving = true;
    this.apis.enableDashboardMonetizationRequest(this.selected.id, { admin_note: (this.adminNote || '').trim() }).subscribe({
      next: () => {
        this.saving = false;
        this.load();
      },
      error: () => {
        this.saving = false;
      },
    });
  }

  load(): void {
    this.loading = true;
    this.selected = null;
    this.apis.getDashboardMonetizationRequests(this.status).subscribe({
      next: (res: any) => {
        const data = res?.data;
        this.items = data?.data || data || [];
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  pick(it: any): void {
    this.selected = it;
    this.adminNote = it?.admin_note || '';
  }

  approve(): void {
    if (!this.selected?.id) return;
    this.saving = true;
    this.apis.approveDashboardMonetizationRequest(this.selected.id, { admin_note: this.adminNote }).subscribe({
      next: () => {
        this.saving = false;
        this.load();
      },
      error: () => {
        this.saving = false;
      },
    });
  }

  reject(): void {
    if (!this.selected?.id) return;
    this.saving = true;
    this.apis.rejectDashboardMonetizationRequest(this.selected.id, { admin_note: this.adminNote || 'Rejected' }).subscribe({
      next: () => {
        this.saving = false;
        this.load();
      },
      error: () => {
        this.saving = false;
      },
    });
  }
}
